import React from 'react';
import styles from "../BaseSimplePage/BaseSimpleItemEditorHeader.module.css";
import {Divider, Typography} from "@mui/material";

const WeightCoefficientsEditorHeader = () => {
    return (
        <div className={styles.main}>
            <Typography variant="h6" sx={{fontWeight: "bold", marginBottom: "10px"}}>
                Редактирование весовых коэффициентов
            </Typography>
            <Divider component="div"/>
        </div>
    );
};

export default WeightCoefficientsEditorHeader;